import React from "react";
import { BrowserRouter as Router, Navigate, Route, Routes } from "react-router-dom";
// import SearchResults from './components/SearchResults';
import "./App.css";
import { HomePage } from "./components/Pages/HomePage";
import { DetailPage } from "./components/Pages/DetailPage";
import { HashratePage } from "./components/Pages/HashratePage";
import { NotFoundPage } from "./components/Pages/NotFoundPage";
import { ConversionPage } from "./components/Pages/ConversionPage";
import { InflationPage } from "./components/Pages/InflationPage";
import { EmissionPage } from "./components/Pages/EmissionPage";
import { FearAndGreedPage } from "./components/Pages/FearAndGreedPage";
import { HalvingPage } from "./components/Pages/HalvingPage";
import { GlossaryPage } from "./components/Pages/GlossaryPage";
import { PerspectiveSharePage } from "./components/Pages/PerspectiveSharePage";

function App() {
  return (
    <Router>
      <div>
        <Routes>
          <Route path="/" Component={HomePage} />
          <Route path="/stats" element={<Navigate to="/hashrate" replace />} />
          <Route path="/detail/:id" Component={DetailPage} />
          <Route path="/hashrate" Component={HashratePage} />
          <Route path="/inflation" Component={InflationPage} />
          <Route path="/emission" Component={EmissionPage} />
          <Route path="/fear-greed" Component={FearAndGreedPage} />
          <Route path="/halving" Component={HalvingPage} />
          <Route path="/convert" Component={ConversionPage} />
          <Route path="/glossary" Component={GlossaryPage} />
          <Route path="/perspective/:id" Component={PerspectiveSharePage} />
          <Route path="*" Component={NotFoundPage} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
